import {
    ERROR_404_TEXT,
    ERROR_CODE_ALREADY_SENT,
    ERROR_PHONE_ALREADY_REGISTERED,
    ERROR_USER_ALREADY_REGISTERED,
    ERROR_USER_BLOCKED_TEXT,
} from "./errorMessages"

export enum ApiErrorCode {
    TokensError = 'TFA-023',
    UserIsBlocked = 'AUTH-019',
    UnexpectedError = 'COMMON-001',
    ReferrerNotFound = 'REFERRER-001',
    UserAlreadyRegistered = 'AUTH-012',
    CodeAlreadySent = 'AUTH-025',
    PhoneAlreadyRegistered = 'AUTH-013',
    FailToGetProductLink = 'AUTH-021',
    WrongLoginOrPassword = 'AUTH-031',
    UserNotFound = 'AUTH-004'
}

export const errorCodesWithMessages = {
    [ApiErrorCode.UserIsBlocked]: ERROR_USER_BLOCKED_TEXT,
    [ApiErrorCode.PhoneAlreadyRegistered]: ERROR_PHONE_ALREADY_REGISTERED,
    [ApiErrorCode.CodeAlreadySent] : ERROR_CODE_ALREADY_SENT,
    [ApiErrorCode.UserAlreadyRegistered] : ERROR_USER_ALREADY_REGISTERED,
    [ApiErrorCode.WrongLoginOrPassword]: ERROR_404_TEXT,
    [ApiErrorCode.UserNotFound]: ERROR_404_TEXT,
} as const satisfies Partial<Record<ApiErrorCode, string>>
